import styled from "styled-components";

export const StatisticsContainer = styled.div`
  width: 100%;
  background-color: #f6f6f6;
  padding: 80px 0;
  margin: 80px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease, transform 0.8s ease;

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 40px 0;
    margin: 40px 0;
  }

  @media (max-width: 480px) {
    padding: 20px 0;
    margin: 20px 0;
  }
`;

export const StatisticsTitle = styled.h2`
  font-size: 56px;
  font-weight: 700;
  font-family: "Pretendard";
  text-align: center;
  line-height: 1.4;
  margin-bottom: 40px;
  white-space: pre-line;
  padding: 0 20px;

  @media (max-width: 1920px) {
    font-size: 48px;
    line-height: 1.4;
    margin-bottom: 20px;
  }

  @media (max-width: 1440px) {
    font-size: 36px;
    line-height: 1.35;
    margin-bottom: 18px;
  }

  @media (max-width: 1024px) {
    font-size: 32px;
    line-height: 1.25;
    margin-bottom: 14px;
  }

  @media (max-width: 768px) {
    width: calc(100% - 40px);
    font-size: 28px;
    line-height: 1.2;
    margin-bottom: 12px;
    padding: 0 20px;
    word-break: keep-all;
  }

  @media (max-width: 480px) {
    width: calc(100% - 40px);
    font-size: 24px;
    line-height: 1.15;
    margin-bottom: 10px;
    padding: 0 10px;
  }
`;

export const StatContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    width: calc(100% - 40px);
    margin-top: 20px;
  }

  @media (max-width: 480px) {
    margin-top: 20px;
  }
`;

export const StatBox = styled.div`
  flex: 1;
  background: #ffffff;
  border-radius: 24px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 300px;
  aspect-ratio: 1 / 1;
  text-align: left;
  box-sizing: border-box;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease, transform 0.8s ease;

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }

  &:nth-child(1) {
    transition-delay: 0.2s;
  }
  &:nth-child(2) {
    transition-delay: 0.4s;
  }
  &:nth-child(3) {
    transition-delay: 0.6s;
  }

  @media (max-width: 768px) {
    padding: 24px;
    min-height: auto;
    aspect-ratio: 3 / 2;
    width: 100%;
  }
`;

export const StatText = styled.div`
  color: #666666;
  font-family: Pretendard;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.6;
  white-space: pre-line;
  text-align: left;
  width: 100%;

  @media (max-width: 1920px) {
    font-size: 20px;
    line-height: 1.55;
  }

  @media (max-width: 1440px) {
    font-size: 18px;
    line-height: 1.5;
  }

  @media (max-width: 1024px) {
    font-size: 16px;
    line-height: 1.45;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.4;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 1.35;
  }
`;

export const BoldText = styled.span`
  color: #000000;
  font-weight: 700;
  font-size: 28px;

  @media (max-width: 1920px) {
    font-size: 24px;
  }

  @media (max-width: 1440px) {
    font-size: 20px;
  }

  @media (max-width: 1024px) {
    font-size: 18px;
    line-height: 1.45;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.4;
  }

  @media (max-width: 480px) {
    font-size: 15px;
    line-height: 1.35;
  }
`;

export const StatNumberContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-top: 24px;
  justify-content: flex-start;
  width: 100%;
`;

export const StatNumber = styled.div`
  color: #000000;
  font-family: Montserrat;
  font-size: 64px;
  font-weight: 700;
  line-height: 1;

  @media (max-width: 1920px) {
    font-size: 56px;
  }

  @media (max-width: 1440px) {
    font-size: 48px;
  }

  @media (max-width: 1024px) {
    font-size: 40px;
  }

  @media (max-width: 768px) {
    font-size: 36px;
  }

  @media (max-width: 480px) {
    font-size: 32px;
  }
`;

export const StatPercent = styled.div`
  color: #666666;
  font-family: Pretendard;
  font-size: 32px;
  font-weight: 600;
  line-height: 1;

  @media (max-width: 1920px) {
    font-size: 28px;
  }

  @media (max-width: 1440px) {
    font-size: 24px;
  }

  @media (max-width: 1024px) {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;
